import React, { useRef, Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../components/global/Button';
import { fileInputAccept } from '../../../../../../constants/photo-upload';
import { ALBUM_SLIDESHOW_STATUS } from '../../../../../../constants/albums';
import { isMainPhotosAlbum } from '../../../../../../util/album';
import videoExtensions from '../../../../../../apps/pro/views/Upload/VideoUpload/helpers';

const videoExtensionsType = videoExtensions
  .map(extension => `.${extension}`)
  .join(',');

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onUpload: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
const AlbumUploadButton = ({ album, disabled, onUpload }) => {
  const ref = useRef();

  return (
    <div className="specialty-event-upload-album-box">
      <Button
        btnBlock
        btnStyle="reset"
        className="w-100 h-100 text-center text-extra-bold text-lg text-primary"
        disabled={disabled}
        onClick={() => ref?.current?.click?.()}
      >
        {album.name}
        {!disabled &&
          isMainPhotosAlbum(album) &&
          album?.slideshow?.status === ALBUM_SLIDESHOW_STATUS.PUBLISHED && (
            <Fragment>
              <br />
              <span className="text-italic text-xs text-normal">
                with live slideshow
              </span>
            </Fragment>
          )}
      </Button>
      <input
        id="uploader"
        type="file"
        className="d-none"
        accept={[videoExtensionsType, fileInputAccept].join(',')}
        multiple
        disabled={disabled}
        onChange={event => {
          onUpload([...event.target.files], album);
        }}
        ref={ref}
      />
    </div>
  );
};

AlbumUploadButton.propTypes = propTypes;

export default AlbumUploadButton;
